const styles = {
  root: {
    backgroundColor: '#d8d7d7',
    width: 600,
  },
};

export default styles;
